export default __webpack_public_path__ + "static/media/close.7abd0ee1.png";